export const STORAGE_LOCK_CHANGE = 'STORAGE_LOCK_CHANGE';
export function change({ status, date, debt }) {
    return {
        type: STORAGE_LOCK_CHANGE,
        data: { status, date, debt },
    };
}
